import { AValueComponent } from "../AValueComponent";
import { ValueChangerController } from "../ValueChangerController";

export class AValueWrapper extends AValueComponent {
    private wrappedTarget: AValueComponent;

    constructor(parent: ValueChangerController, minValue: number, maxValue: number, toWrap: AValueComponent) {
        super(parent, minValue, maxValue);
        this.wrappedTarget = toWrap;
        this.wrappedTarget.updatedByUserSignal.add(this.bindFunction(this.wrappedUpdateByUserChanges));
    }

    protected wrappedUpdateByUserChanges(value: number): void {
        this.dispatchUpdateByUserSignal(value);
    }

    public updateValue(value: number): void {

        super.updateValue(value);
        this.wrappedTarget.updateValue(value);
    }

    public dispose(): void {
        super.dispose();
        this.wrappedTarget.dispose();
    }
}
